/**
 * Returns an array element for which accessor function returns minimal value.
 */
export function elementWithMin<TItem, TValue = TItem>(
    array: TItem[],
    accessor?: (item: TItem, index?: number, array?: TItem[]) => TValue
): TItem {
    if (!array || !array.length) {
        throw new Error("Array is not defined or empty.");
    }

    accessor = accessor || (i => i as any);

    let result: TItem = array[0];

    for (let i = 1; i < array.length; i++) {
        if (accessor(result) > accessor(array[i], i, array)) {
            result = array[i];
        }
    }

    return result;
}
